/* !
 * jQuery shops v1.0.0
 * Copyright 2017, Connecty Inc.
 */
(function($){
	const a = 'is-active';
	const v = 'is-visible';

	if($('.business-accommodation-slide').length) {
		$('.business-accommodation-slide').slick({
			dots:true,
			prevArrow: '<a class="slick-prev" href="#"><i class="icon icon-arrow_left"></i></a>',
			nextArrow: '<a class="slick-next" href="#"><i class="icon icon-arrow_right"></i></a>',
			customPaging: function(slick,index) {
				var targetImage = slick.$slides.eq(index).find('img').attr('src');
				return '<img src=" ' + targetImage + ' "/>';
			}
		});
		let imgHeight = $('.slick-arrow').eq(1).height() / 2;
		let arrowHeight = $('.slick-slide img').eq(1).height() / 2;
		$(window).resize(function() {
			imgHeight = $('.slick-arrow').eq(1).height() / 2;
			arrowHeight = $('.slick-slide img').eq(1).height() / 2;
			$('.slick-arrow').css('top',arrowHeight-imgHeight);
		});
	}
	
	/* ---------------------------------------------- functions ---------------------------------------------- */

})(window.jQuery);
$(window).on('load', function(){
	let imgHeight = $('.slick-arrow').eq(1).height() / 2;
	let arrowHeight = $('.slick-slide img').eq(1).height() / 2;
	$('.slick-arrow').css('top',arrowHeight-imgHeight);
});